import { defineWave } from '../schema';

/** BLOC F3 — LES LAMES. Introduit le laser et la spirale, et remplace la
 *  reprise de F1 au monde 3.
 *
 *  ── Pourquoi elle existe ──
 *  Le monde 3 rejouait F1 à mi-parcours, faute d'une brique de plus. Un joueur
 *  le ressent : « ça se répète ». Cette vague comble le trou ET déploie deux des
 *  quatre archétypes à conduite exotique, chacun introduit selon la discipline
 *  du bestiaire — seul d'abord, dans le bruit ensuite.
 *
 *  ── Le Sabreur en premier, et SEUL ──
 *  Son laser vertical balaie toute la hauteur : c'est la menace la plus inédite
 *  du jeu, et la seule qu'on ne peut pas « esquiver au jugé ». Les six premières
 *  secondes ne contiennent que lui, au centre, pour que le joueur voie le trait
 *  s'allumer et comprenne qu'il faut passer du côté déjà balayé — pas foncer
 *  dedans. Une leçon donnée au milieu d'un rideau n'est pas une leçon.
 *
 *  ── Puis le Tourbillon ──
 *  Sa spirale demande d'anticiper l'arc d'une balle, pas sa ligne droite. Elle
 *  arrive une fois le laser lu, jamais avant : deux menaces neuves ensemble, ce
 *  serait deux leçons qu'on subit au lieu d'en apprendre une.
 *
 *  ⚠️ 28 s, exactement la durée de F1 qu'elle remplace : la timeline du monde 3
 *  ne bouge pas d'une seconde, donc ni les respirations ni le silence
 *  d'avant-boss ne sont touchés. */
export default defineWave({
  id: 'f3-lames',
  duration: 28,
  spawns: [
    // Le Sabreur, seul, au centre : on regarde le laser balayer.
    { at: 0.5, enemy: 'sabreur', lane: 3, count: 1, spacing: 0 },
    // Un peu de piétaille pour ne pas laisser l'écran vide pendant qu'on lit.
    { at: 6.0, enemy: 'mite', lane: 1, count: 6, spacing: 0.08 },
    // Le Tourbillon entre une fois le laser compris.
    { at: 9.0, enemy: 'tourbillon', lane: 3, count: 1, spacing: 0 },
    { at: 13.0, enemy: 'sabreur', lane: 2, count: 1, spacing: 0 },
    { at: 13.5, enemy: 'sabreur', lane: 4, count: 1, spacing: 0 },
    // Prisme : faisceau pleine hauteur, télégraphié. Deuxième nature de laser
    // après le Sabreur, cohérente avec le thème « les lames ». Posé seul et au
    // centre : sa colonne condamnée doit se lire, on évacue la zone à l'avance.
    { at: 16.0, enemy: 'prisme', lane: 3, count: 1, spacing: 0 },
    { at: 17.0, enemy: 'dard', lane: 3, count: 4, spacing: 0.45 },
    { at: 20.0, enemy: 'tourbillon', lane: 1, count: 1, spacing: 0 },
    { at: 20.4, enemy: 'tourbillon', lane: 5, count: 1, spacing: 0 },
    // Pondeuse : cible prioritaire. Elle pond des œufs qui éclosent — la laisser
    // vivre, c'est voir la menace se multiplier. On apprend à couper la source.
    { at: 22.0, enemy: 'pondeuse', lane: 2, count: 1, spacing: 0 },
    { at: 24.0, enemy: 'mite', lane: 3, count: 9, spacing: 0.07 },
  ],
});
